import { createSlice } from '@reduxjs/toolkit';
import type Feature from '@alltrails/types/Feature';

export const features = createSlice({
  name: 'features',
  initialState: [] as Feature[],
  reducers: {}
});

export default features.reducer;
